import * as React from "react";
import {
    IGenericUserProps,
    genericMapStateToProps,
} from "../../../DataClasses/GenericUser";
import { Theme, createStyles } from '@mui/material/styles';
import { WithStyles, withStyles } from '@mui/styles';
import idssStyle from "../../../Configuration/SharedStyling";
import { connect } from "react-redux";
import { Grid2 as Grid, Dialog, DialogTitle, Button, Divider, DialogContent, DialogActions, Link, TextField, CircularProgress } from "@mui/material";
import SharedMaterialReactTable, { ISharedTableColumn } from "../../Shared/MaterialReactTable";
import AdministrationService from "../../Services/AdministrationService";
import { AjaxError } from "rxjs/ajax";
import { firstValueFrom } from "rxjs";
import MuiAlert from "@mui/material/Alert";

const styles = (theme: Theme) => createStyles({
    ...idssStyle(theme),
    paperStyle: {
        flexGrow: 0,
        padding: theme.spacing(2, 2),
        width: "55%"
    }
});

interface IEssAdminStateStore {
    isLoading: boolean;
    inputOrgIds: string;
    tableData: any[];
    redirect: boolean;
    subsDialogOpen: boolean;
    selectedOrgId: number;
    selectedOrgName: string;
    editOrgDialogOpen: boolean;
    editingOrgId: number;
    editingOrgName: string;
    origOrgName: string;
    updateSuccess: boolean;
    editOrgContactDialogOpen: boolean;
    editingFirstName: string;
    editingLastName: string;
    contactNameTouched: boolean;
    iframeLoaded: boolean;
}

interface LocalProps {
    measurementYear: number
}

type Props = LocalProps & WithStyles<typeof styles>;

class EssAdminView extends React.Component<
    IGenericUserProps & Props,
    IEssAdminStateStore
> {
    constructor(props: any) {
        super(props);
        this.state = {
            isLoading: true,
            inputOrgIds: "",
            tableData: [],
            redirect: false,
            subsDialogOpen: false,
            selectedOrgId: -1,
            selectedOrgName: "",
            editOrgDialogOpen: false,
            editingOrgId: -1,
            editingOrgName: "",
            origOrgName: "",
            updateSuccess: false,
            editOrgContactDialogOpen: false,
            editingFirstName: "",
            editingLastName: "",
            contactNameTouched: false,
            iframeLoaded: false
        }
    }

    public async componentDidMount() {
        this.setState({ isLoading: true });
        await this.refreshModel();
        this.setState({ isLoading: false });
    }

    private setRedirectState() {
        this.setState({ redirect: true });
    }

    // Template for View/Edit Submissions column
    private viewEditSubmissionTemplate = (rowData: any) => {
        return this.customBodyRender_ViewEditSubmission(rowData.eisOrgId);
    };

    // Template for Account Managers column
    private accountManagerTemplate = (rowData: any) => {
        return this.customBodyRender_OrgContact(rowData.eisOrgId);
    };

    private getTableColumns = (): ISharedTableColumn<any>[] => [
        {
            accessorKey: 'eisOrgId',
            header: 'OrgId',
            enableSorting: true,
            enableFiltering: true,
            size: 50
        },
        {
            accessorKey: 'orgName',
            header: 'OrgName',
            enableSorting: true,
            enableFiltering: true,
            size: 200,
        },
        {
            accessorKey: 'viewEditSubmissions',
            header: 'View/Edit Submissions',
            enableSorting: false,
            enableFiltering: false,
            size: 120,
            Cell: ({ row }) => this.viewEditSubmissionTemplate(row.original),
        },
        {
            accessorKey: 'contactFirstName',
            header: 'ContactFirstName',
            enableColumnActions: false,
            enableSorting: false,
            enableFiltering: false,
            size: 120
        },
        {
            accessorKey: 'contactLastName',
            header: 'ContactLastName',
            enableColumnActions: false,
            enableSorting: false,
            enableFiltering: false,
            size: 120
        },
        {
            accessorKey: 'accountManagers',
            header: 'Account Managers',
            enableSorting: false,
            enableFiltering: false,
            size: 120,
            Cell: ({ row }) => this.accountManagerTemplate(row.original),
        },
    ];


    public render() {
        const { classes } = this.props;

        const now = new Date();
        const timestamp = now.toISOString().replace(/[-:T]/g, '').slice(0, 15);

        return (
            <div>
                <Grid size={6}>
                    <SharedMaterialReactTable
                        data={this.state.tableData}
                        columns={this.getTableColumns()}
                        title="Organizations / Submissions List"
                        isLoading={this.state.isLoading}
                        enablePagination={true}
                        enableSorting={true}
                        enableFiltering={true}
                        enableColumnActions={true}
                        enableRowActions={false}
                        initialState={{
                            pagination: { pageIndex: 0, pageSize: 10 },
                        }}
                        muiPaginationProps={{
                            rowsPerPageOptions: [10, 15, 20, 25, 50, 75, 100, 500, 1000],
                        }}
                        emptyMessage="No organizations found."
                        renderTopToolbarCustomActions={() => (
                            <Link
                                component="button"
                                onClick={() => this.setState({ editOrgDialogOpen: true })}
                                style={{ textDecoration: 'underline' }}
                            >
                                Add / Edit Org
                            </Link>
                        )}
                    />
                </Grid>
                <Dialog open={this.state.subsDialogOpen} onClose={() => this.submissionsDialogClose()} classes={{ paper: classes.dialogXL }}>
                    <DialogTitle id="max-width-dialog-title">
                        Submissions for Org: {this.state.selectedOrgId} - {this.state.selectedOrgName}
                    </DialogTitle>
                    <Divider />
                    <DialogContent>
                        {!this.state.iframeLoaded && <CircularProgress />}
                        <iframe
                            title="essIFrame"
                            src={`https://essstagepro.ncqa.org/SalesForce/Submissions?orgid=${this.state.selectedOrgId}`}
                            width="100%"
                            height="600"
                            style={{ border: 'none' }}
                            onLoad={() => this.setState({ iframeLoaded: true })}
                        ></iframe>
                    </DialogContent>
                    <Divider />
                    <DialogActions>
                        <Button
                            onClick={() => this.submissionsDialogClose()}
                        >
                            ClOSE
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={this.state.editOrgDialogOpen} onClose={() => this.editOrgDialogClose()} classes={{ paper: classes.dialogS }}>
                    <DialogTitle id="max-width-dialog-title">
                        Add / Edit Org
                    </DialogTitle>
                    <Divider />
                    <DialogContent>
                        <form noValidate autoComplete="off">
                            <Grid container spacing={2}>
                                <Grid size={3}>
                                    <TextField
                                        label="OrgId"
                                        variant="outlined"
                                        InputLabelProps={{ shrink: true }}
                                        fullWidth
                                        value={this.state.editingOrgId === -1 ? "" : this.state.editingOrgId}
                                        onChange={e => {
                                            this.afterEditingOrgIdChange(e.target.value);
                                        }
                                            // Ignore invalid input (letters, symbols)
                                        }
                                    />
                                </Grid>
                                {this.state.editingOrgId < 0 &&
                                    < Grid size={9}>
                                        <MuiAlert severity="info">
                                            Enter an existing OrgId to edit, or a new OrgId to create.
                                        </MuiAlert>
                                    </Grid>
                                }
                                {this.state.origOrgName && this.state.origOrgName.length > 0 &&
                                    < Grid size={9}>
                                        <TextField
                                            label="Original Org Name"
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                            fullWidth
                                            value={this.state.origOrgName}
                                            disabled
                                        />
                                    </Grid>
                                }
                                {this.state.editingOrgId !== null && this.state.editingOrgId > 0 &&
                                    <Grid size={12}>
                                        <TextField
                                            label="OrgName To Be"
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                            fullWidth
                                            value={this.state.editingOrgName}
                                            onChange={e => this.setState({ editingOrgName: e.target.value })}
                                        />
                                    </Grid>
                                }
                                {
                                    this.state.updateSuccess &&
                                    <Grid size={6}>
                                        <MuiAlert elevation={6} variant="filled" >Successfully Updated!</MuiAlert>
                                    </Grid>
                                }
                            </Grid>
                        </form>
                    </DialogContent>
                    <Divider />
                    <DialogActions>
                        {
                            this.state.origOrgName === "" && this.state.editingOrgId > 0 &&
                            <Button
                                disabled={this.state.editingOrgName.trim().length === 0}
                                onClick={async () => await this.UpdateOrganization()}
                            >
                                CREATE
                            </Button>
                        }
                        {
                            this.state.origOrgName && this.state.origOrgName.length > 0 &&
                            <Button
                                disabled={this.state.editingOrgName.trim().length === 0}
                                onClick={async () => await this.UpdateOrganization()}
                            >
                                UPDATE
                            </Button>
                        }
                        {
                            this.state.editingOrgId > 0 &&
                            <Button
                                onClick={() => this.resetEditOrgForm()}
                            >
                                RESET
                            </Button>
                        }
                        <Button
                            onClick={() => this.editOrgDialogClose()}
                        >
                            ClOSE
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={this.state.editOrgContactDialogOpen} onClose={() => this.editOrgContactDialogClose()} classes={{ paper: classes.dialogS }}>
                    <DialogTitle id="max-width-dialog-title">
                        Account Manager for Org: {this.state.selectedOrgId} - {this.state.selectedOrgName}
                    </DialogTitle>
                    <Divider />
                    <DialogContent>
                        <form noValidate autoComplete="off">
                            <Grid container spacing={2}>
                                <Grid size={10}>
                                    <TextField
                                        label="First Name"
                                        variant="outlined"
                                        InputLabelProps={{ shrink: true }}
                                        fullWidth
                                        value={this.state.editingFirstName}
                                        onChange={e => {
                                            this.setState({ editingFirstName: e.target.value, contactNameTouched: true });
                                        }
                                        }
                                    />
                                </Grid>
                                <Grid size={10}>
                                    <TextField
                                        label="Last Name"
                                        variant="outlined"
                                        InputLabelProps={{ shrink: true }}
                                        fullWidth
                                        value={this.state.editingLastName}
                                        onChange={e => {
                                            this.setState({ editingLastName: e.target.value, contactNameTouched: true });
                                        }
                                        }
                                    />
                                </Grid>
                                {
                                    this.state.updateSuccess &&
                                    <Grid size={6}>
                                        <MuiAlert elevation={6} variant="filled" >Successfully Updated!</MuiAlert>
                                    </Grid>
                                }
                            </Grid>
                        </form>
                    </DialogContent>
                    <Divider />
                    <DialogActions>
                        <Button
                            disabled={!this.state.contactNameTouched || this.state.editingFirstName.trim().length === 0 || this.state.editingLastName.trim().length === 0}
                            onClick={async () => await this.SaveOrgContact()}
                        >
                            SAVE
                        </Button>
                        <Button
                            onClick={() => this.editOrgContactDialogClose()}
                        >
                            ClOSE
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
    private getOrgName(orgId: number): string {
        const org = this.state.tableData.find(x => x.eisOrgId === orgId);
        return org?.orgName || "";
    }
    private async SaveOrgContact() {
        this.setState({ contactNameTouched: false });
        const retval = await firstValueFrom(AdministrationService.UpdateOrgContact$(
            this.props.user,
            this.state.selectedOrgId,
            this.state.editingFirstName,
            this.state.editingLastName
        ));
        if (retval instanceof AjaxError || !retval) {
            this.setRedirectState();
        }
        await this.refreshModel();
        this.setState({ updateSuccess: true });
        setTimeout(() => {
            this.setState({ updateSuccess: false });
        }, 4000);
    }

    private async UpdateOrganization() {
        const retval = await firstValueFrom(AdministrationService.UpdateOrganization$(
            this.props.user,
            this.state.editingOrgId,
            this.state.editingOrgName
        ));
        if (retval instanceof AjaxError || !retval) {
            this.setRedirectState();
        }
        await this.refreshModel();
        this.setState({ updateSuccess: true, origOrgName: this.state.editingOrgName, editingOrgName: "" });
        setTimeout(() => {
            this.setState({ updateSuccess: false });
        }, 4000);
    }

    private resetEditOrgForm() {
        this.setState({ editingOrgId: -1, origOrgName: "", editingOrgName: "" });
    }
    private afterEditingOrgIdChange(value: any) {
        // Only allow empty or valid integer
        if (value === "") {
            this.setState({ editingOrgId: -1, origOrgName: "" });
        } else if (/^\d+$/.test(value)) {
            const orgId = parseInt(value, 10);
            const org = this.state.tableData.find(x => x.eisOrgId === orgId);
            this.setState({ editingOrgId: orgId, origOrgName: org ? org.orgName : "" });
        }
    }

    private editOrgDialogClose() {
        this.setState({ editOrgDialogOpen: false, editingOrgId: -1, editingOrgName: "", origOrgName: "" });
    }
    private OrgContactDialogOpen(value: any) {
        const row = this.state.tableData.find(x => x.eisOrgId === value);

        this.setState({
            selectedOrgId: value,
            selectedOrgName: row?.orgName || "",
            editOrgContactDialogOpen: true,
            editingFirstName: row?.contactFirstName || "",
            editingLastName: row?.contactLastName || "",
        });
    }
    private editOrgContactDialogClose() {
        this.setState({ editOrgContactDialogOpen: false, selectedOrgId: -1, selectedOrgName: "", editingFirstName: "", editingLastName: "" });
    }

    private customBodyRender_OrgContact(value: any) {
        const row = this.state.tableData.find(x => x.eisOrgId === value);
        let fullName = "Add";

        if (row?.contactFirstName && row.contactFirstName.length > 0) {
            fullName = `${row.contactFirstName} ${row.contactLastName || ''}`;
        }

        return (
            <Link
                component="button"
                onClick={() => this.OrgContactDialogOpen(value)}
                style={{ textDecoration: 'underline' }}
            >
                {fullName}
            </Link>
        );
    }

    private customBodyRender_ViewEditSubmission(value: any) {
        return (
            <Link
                component="button"
                onClick={() => this.submissionsDialogOpen(value)}
            >
                <i><u>View/Edit Submissions</u></i>
            </Link>
        )
    }

    private submissionsDialogOpen(value: any) {
        const orgName = this.getOrgName(value);
        this.setState({ selectedOrgId: value, selectedOrgName: orgName, subsDialogOpen: true });
    }

    private submissionsDialogClose() {
        this.setState({ selectedOrgId: -1, selectedOrgName: "", subsDialogOpen: false, iframeLoaded: false });
    }

    private async refreshModel() {
        const retval = await firstValueFrom(AdministrationService.GetAllOrganizationsWithContact$(
            this.props.user
        ));
        if (retval instanceof AjaxError || !retval) {
            this.setRedirectState();
        } else {
            this.setState({ tableData: retval });
        }
    }
}

const EssAdminPageWithState = connect<IGenericUserProps>(
    genericMapStateToProps
)(EssAdminView);

// STYLES CONTAINER
const EssAdminPage = withStyles(styles)(
    EssAdminPageWithState
);

export default EssAdminPage;
